package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.repository.PlaceRepository

/**
 * Records another visit to a place. [imageFileName] is a photo already written to the
 * local image store — the visit only carries its name.
 */
class AddVisitUseCase(
    private val repository: PlaceRepository,
) {
    suspend operator fun invoke(
        placeId: String,
        visitedAt: Long,
        note: String? = null,
        emotion: String? = null,
        imageFileName: String? = null,
    ) = repository.addVisit(placeId, visitedAt, note, emotion, imageFileName)
}
